export default __webpack_public_path__ + "static/media/micidial.a90b1871.png";